module.exports = __webpack_public_path__ + "img/IMG_2024_L_Foamcore_MockedUp.82a8a175.jpg";